<template>
  <b-sidebar
    id="add-new-departament-sidebar"
    :visible="isAddNewDepartamentSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    width="500"
    @change="(val) => $emit('update:is-add-new-departament-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- @hidden="resetForm" -->
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('humanResources.departament.addNew.addDepartament') }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <!--Name Departament field--->
          <validation-provider
            #default="validationContext"
            name="nombre"
            rules="required"
          >
            <b-form-group
              :label="$t('humanResources.departament.columns.departament')"
            >
              <b-form-input
                v-model="departamentData.nombre"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!--description field--->
          <validation-provider
            #default="validationContext"
            name="Description"
            rules="required"
          >
            <b-form-group
              :label="$t('humanResources.departament.columns.description')"
            >
              <b-form-input
                v-model="departamentData.descripcion"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!--departament supervisa select--->
          <validation-provider
            #default="{ errors }"
            name="departamento-supervisa"
            rules="required"
          >
            <b-form-group
              :label="$t('humanResources.departament.columns.superviseDepartament')"
              :state="errors.length > 0 ? false:null"
            >
              <v-select
                v-model="departamentData.departamentoSupervisaId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                label="texto"
                :reduce="option => option.id"
                :options="departamentsOptions"
              />
              <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!--employe select--->
          <validation-provider
            #default="{ errors }"
            name="manager"
            rules="required"
          >
            <b-form-group
              :label="$t('humanResources.departament.columns.manager')"
              :state="errors.length > 0 ? false:null"
            >
              <v-select
                v-model="departamentData.empleadoGerenteId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                label="texto"
                :reduce="option => option.id"
                :options="employees"
              />
              <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ $t('Lists.Add') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{ $t('Lists.Cancel') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BButton,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import {
  required,
} from '@validations'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import humanResources from '@/services/humanresources.service'

export default {
  components: {
    BSidebar,
    ValidationObserver,
    BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    vSelect,
  },
  props: {
    isAddNewDepartamentSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    /* Services */
    const {
      createDepartament,
      fetchDepartamentsOptions,
      fetchEmployesOptions,
    } = humanResources()
    /* Data */
    const blankDepartamentData = {
      departamentoId: null,
      nombre: '',
      descripcion: '',
      departamentoSupervisaId: null,
      empleadoGerenteId: null,
    }
    const departamentData = ref(JSON.parse(JSON.stringify(blankDepartamentData)))
    const resetClassificationData = () => {
      departamentData.value = JSON.parse(JSON.stringify(blankDepartamentData))
    }
    const departamentsOptions = ref([])
    const employees = ref([])

    fetchDepartamentsOptions(data => {
      departamentsOptions.value = data
    })
    fetchEmployesOptions(data => {
      employees.value = data
    })
    /* Events */
    const onSubmit = () => {
      createDepartament(departamentData.value)
        .then(() => {
          emit('update:is-add-new-departament-sidebar-active', false)
          emit('refresh-data')
        })
    }

    /* Validations */
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetClassificationData)

    return {
      // Data
      departamentData,
      departamentsOptions,
      employees,
      // Events
      onSubmit,
      // Validations
      required,
      getValidationState,
      resetForm,
      refFormObserver,
    }
  },
}
</script>

<style>

</style>
